import type {Step} from "./Step.ts";
import {useCurrentStep} from "./useCurrentStep.ts";
import {StepsDisplay} from "./StepsDisplay.tsx";
import {SuspenseLayer} from "../../util/suspense/SuspenseLayer.tsx";
import {StepArrows} from "./StepArrows.tsx";
import type {SetterVal} from "../../util/setter/Setter.ts";
import {StepperCtx, useStepContextState} from "./StepContext.ts";
import {useSetAtom} from "jotai";
import {currentStepIdAtom} from "./currentStepAtom.ts";
import {useEffect} from "react";

interface Props {
    steps: Step[]
}
export function StepsWrapper({steps}: Props) {
    const {locked, ctxState} = useStepContextState()
    const {currentStepId, setCurrentStepId, Widget} = useCurrentStep(steps)
    const setSharedStepId = useSetAtom(currentStepIdAtom)
    useEffect(() => {
        setSharedStepId(currentStepId)
    }, [currentStepId, setSharedStepId])
    const setCurrentStepIdWrap = (step: SetterVal<number>) => {
        if(!locked) {
            setCurrentStepId(step)
        }
    }

    return <>
        <StepperCtx.Provider value={ctxState} >
            <StepsDisplay steps={steps} currentStep={currentStepId} setCurrentStep={setCurrentStepIdWrap} locked={locked} />
            <StepArrows steps={steps} currentStep={currentStepId} setCurrentStep={setCurrentStepIdWrap} locked={locked}>
                <SuspenseLayer>
                    <Widget />
                </SuspenseLayer>
            </StepArrows>
        </StepperCtx.Provider>
    </>
}